
import React from 'react';
import Layout from '@/components/Layout/Layout';
import { Link } from 'react-router-dom';
import { ArrowLeft, Baby } from 'lucide-react';
import PregnancyCalculator from '@/components/SpecialCalculators/PregnancyCalculators/PregnancyCalculator';

const PregnancyCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/special" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to Special Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Pregnancy Calculator</h1>
          <p className="text-gray-600 mb-6">
            Track your pregnancy journey week by week and estimate your due date.
          </p>
        </div>
        
        <div className="mb-8">
          <PregnancyCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About the Pregnancy Calculator</h2>
          <p>
            The pregnancy calculator helps you track your pregnancy progress based on your last menstrual
            period or conception date. It provides information about your due date, current trimester,
            and pregnancy milestones.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How It Works</h3>
          <p>
            If you enter your last menstrual period (LMP), the calculator adds 280 days (40 weeks) to
            determine your due date. If you enter the conception date, it adds 266 days (38 weeks).
            The calculator then determines your current week of pregnancy and trimester based on today's date.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Understanding Pregnancy Weeks</h3>
          <ul className="list-disc ml-6">
            <li><strong>First Trimester:</strong> Weeks 1-13</li>
            <li><strong>Second Trimester:</strong> Weeks 14-26</li>
            <li><strong>Third Trimester:</strong> Weeks 27-40</li>
          </ul>
          
          <div className="bg-blue-50 p-4 rounded-md mt-6">
            <div className="flex items-center mb-2">
              <Baby className="h-5 w-5 text-blue-600 mr-2" />
              <h3 className="text-lg font-medium text-blue-800">Remember</h3>
            </div>
            <p className="text-blue-800">
              Only about 5% of pregnancies deliver on the actual due date. The due date is just an estimate,
              and most babies are born within two weeks before or after this date.
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PregnancyCalculatorPage;
